import {TrackingAPI} from 'api/tracking';
import {Checkbox} from 'components/system/checkbox';
import Link from 'next/link';
import styles from './simple_course_section_list.module.css';

export const CourseSectionList = ({sections = [], learningPathSlug, courseSlug}: Props) => {
  return (
    <>
      {sections.map((section) => {
        const {uuid, title, sub_description, is_completed, slug} = section;

        const trackSectionClick = (e: any) => TrackingAPI.courseLinkClicked(section);

        return (
          <div key={`cs-${title}`}>
            <Link
              prefetch={false}
              href={`/learning-paths/${learningPathSlug}/${courseSlug}/${slug}`}>
              <a>
                <div className={styles.linkWrapper} onClick={trackSectionClick}>
                  <div className={styles.alignLayout}>
                    <Checkbox value={is_completed} />
                    <a className={styles.link}>{title}</a>
                  </div>
                  <span className={styles.time}>{`(${sub_description})`}</span>
                </div>
              </a>
            </Link>
          </div>
        );
      })}
    </>
  );
};

type Props = {
  sections: SectionIndexItem[];
  learningPathSlug: string;
  courseSlug: string;
};
